var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPropertyDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.28 3.36a.9.9 0 0 1 1.238-.197L19.407 6.6H10.85l2.43-3.24zm9.271 2.34a.45.45 0 0 1 .081.892l-.08.008H20.75a.45.45 0 0 1-.08-.893l.08-.007h1.801zm-13.05.45a.45.45 0 0 0-.45-.45h-1.8l-.154.005A2.257 2.257 0 0 0 5 7.95V21.7c0 1.1.901 2 2 2h15.801c1.1 0 2-.9 2-2V9.5c0-1.1-.9-2-2-2H7c-.403 0-.779.12-1.094.328V7.82A1.357 1.357 0 0 1 7.25 6.6h1.801l.081-.008a.45.45 0 0 0 .37-.442zM22.892 12V9.5a.097.097 0 0 0-.091-.091H7a.097.097 0 0 0-.091.09v12.2c0 .047.045.092.091.092h15.801a.097.097 0 0 0 .091-.091v-2.5h-3.634c-1.91 0-3.456-1.612-3.456-3.6s1.546-3.6 3.456-3.6H22.892zm-2.591 3.6a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0zm2.56 1.66v-3.32h-3.603c-.836 0-1.517.745-1.517 1.66 0 .915.68 1.66 1.517 1.66H22.86z",
    fill: "url(#jaebjt2dza)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jaebjt2dza",
    x1: 5.245,
    y1: 3.511,
    x2: 5.245,
    y2: 23.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57E68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BE5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPropertyDark);
export default __webpack_public_path__ + "static/media/ic-property-dark.c0fc082cd20ef0f5fc028f7bc282d46a.svg";
export { ForwardRef as ReactComponent };